let dbPromise = new Promise((resolve, reject) => {
  let request = indexedDB.open('storageDB', 1)

  request.onupgradeneeded = function (event) {
    let db = event.target.result
    if (!db.objectStoreNames.contains('storage')) {
      db.createObjectStore('storage', { keyPath: 'key' })
    }
  }

  request.onsuccess = function (event) {
    resolve(event.target.result)
  }

  request.onerror = function (event) {
    reject('IndexedDB error: ' + event.target.errorCode)
  }
})

let STORAGE_ENGINE = {
  setItem: async (key, value) => {
    try {
      let db = await dbPromise
      let transaction = db.transaction(['storage'], 'readwrite')
      let store = transaction.objectStore('storage')
      store.put({ key: key, value: value })
      return transaction.complete
    } catch (err) {
      console.log(err)
    }
  },
  getItem: async key => {
    try {
      let db = await dbPromise
      let transaction = db.transaction(['storage'], 'readonly')
      let store = transaction.objectStore('storage')
      let request = store.get(key)
      return new Promise((resolve, reject) => {
        request.onsuccess = function (event) {
          resolve(event.target.result ? event.target.result.value : null)
        }
        request.onerror = function (event) {
          reject('IndexedDB error: ' + event.target.errorCode)
        }
      })
    } catch (err) {
      console.log(err)
    }
  },
  removeItem: async key => {
    try {
      let db = await dbPromise
      let transaction = db.transaction(['storage'], 'readwrite')
      let store = transaction.objectStore('storage')
      store.delete(key)
      return transaction.complete
    } catch (err) {
      console.log(err)
    }
  },
}

export let storage = {
  setItem: (key, value) => STORAGE_ENGINE.setItem(key, value),
  getItem: key => STORAGE_ENGINE.getItem(key),
  removeItem: key => STORAGE_ENGINE.removeItem(key),
}
